<template>
    <b-container>
        <b-row class="d-flex justify-content-center">
            <div class="main-title">Admin dashboard</div>
        </b-row>
        <b-row>
          <b-col></b-col>
          <b-col></b-col>
          <b-col></b-col>
        </b-row>
    </b-container>
</template>
<script>
export default {
    data() {
        return {       
        }
	},    
    methods: {	
    },
}
</script>


// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue